import { ProductReviewDetail } from 'components/reviews/product-review-detail/ProductReviewDetail'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { setModal, setOptions } from 'reducers/listReducer'
import { SORT_PRODUCT_REVIEW_DETAIL, TABLE_PRODUCT_REVIEW_DETAIL } from 'configs/reviews/configProductReviewDetail'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useFetch } from 'services/useFetch'
import { API_REVIEW } from 'services/apiReview'
import { downloadFile, getAllQueryParams, getObjectName, getValueFromArray, setQueryParams } from 'utils/utils'
import moment from 'moment'

export const ProductReviewDetailContainer = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const productId = searchParams.get('productId')
    const { query: INITIAL_DATA_FILTER, selectedValue } = useSelector((state) => state.listReducer)
    const query = getAllQueryParams(searchParams)
    const {
        fetching: getProductReviewDetailApi,
        data: productReviewDetail,
        isLoading,
    } = useFetch({ ...API_REVIEW.PRODUCT_REVIEW_DETAIL, initPathVariable: productId }, INITIAL_DATA_FILTER)
    const { data: productReviewStatistic } = useFetch(
        { ...API_REVIEW.PRODUCT_REVIEW_STATISTIC, initPathVariable: productId },
        {},
        { isFetching: true },
    )
    const { fetching: exportUserReviewListApi, isLoading: isLoadingExport } = useFetch({
        ...API_REVIEW.EXPORT_USER_REVIEW_LIST,
        initPathVariable: productId,
    })

    useEffect(() => {
        dispatch(
            setOptions({
                sort: SORT_PRODUCT_REVIEW_DETAIL,
                table: TABLE_PRODUCT_REVIEW_DETAIL,
                tab: [],
            }),
        )
    }, [])

    useEffect(() => {
        const { productId, ...queryParams } = query
        getProductReviewDetailApi(queryParams)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'skin_type'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onChangeTab = (item) => {
        onChangeQuery({ ...INITIAL_DATA_FILTER, ...item })
    }

    const onExport = () => {
        const payload = { review_ids: getValueFromArray(selectedValue?.selectedIds, 'id'), ...query }
        exportUserReviewListApi(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Review-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            dispatch(setModal({ export: false }))
        })
    }

    const props = {
        productDetailStatistic: productReviewStatistic?.data,
        skinType: productReviewDetail?.data?.user_choices,
        dataList: productReviewDetail?.data?.reviews,
        query: { ...INITIAL_DATA_FILTER, ...query },
        onChangeQuery,
        onChangeTab,
        isLoading,
        isLoadingExport,
        onExport,
        isResetSelectedItem,
    }
    return <ProductReviewDetail {...props} />
}
